import { useEffect, useRef, useState } from "react";

const testimonios = [
  {
    quote: "Antes perdía ventas por no saber qué productos me quedaban. Con Stock Simple mi embudo fluye sin cortes. El control de inventario me cambió el juego. Recomendado al 100%.",
    name: "Carlos M.",
    role: "E-commerce · Lima",
    avatar: "https://readdy.ai/api/search-image?query=professional%20latin%20man%20headshot%20portrait%2C%20confident%20business%20owner%2C%20dark%20background%2C%20warm%20neutral%20tones%2C%20professional%20photography%2C%20close-up%20face&width=80&height=80&seq=avatar-carlos-05&orientation=squarish",
    accent: "#00FF88",
    size: "large",
  },
  {
    quote: "Descubrí fugas de dinero tontas que no veía. Una inversión de 25 soles me salvó el mes.",
    name: "Lucía R.",
    role: "Traficker · Arequipa",
    avatar: "https://readdy.ai/api/search-image?query=professional%20latin%20woman%20headshot%20portrait%2C%20confident%20businesswoman%2C%20dark%20background%2C%20warm%20neutral%20tones%2C%20professional%20photography%2C%20close-up%20face&width=80&height=80&seq=avatar-lucia-06&orientation=squarish",
    accent: "#FF6B35",
    size: "small",
  },
];

const faqs = [
  {
    q: "¿Es pago único o mensual?",
    a: "Anual. Solo S/ 25 por 365 días de acceso completo a ambos sistemas (Stock Simple + Budgettrack) y los 2 PDFs bonus. Sin costos ocultos, sin sorpresas.",
  },
  {
    q: "¿Necesito saber de tecnología?",
    a: "Cero. Diseñado bajo la filosofía 'cero fricción'. Si puedes usar WhatsApp, puedes usar este sistema. Interfaz intuitiva para cualquier nivel.",
  },
  {
    q: "¿Es seguro?",
    a: "Totalmente respaldado en la nube. Tus datos están seguros y accesibles en cualquier momento desde cualquier dispositivo.",
  },
  {
    q: "¿Cómo accedo?",
    a: "Tras procesar tu pago, recibes acceso automático a los sistemas y PDFs. Sin esperas, sin formularios complicados. Inmediato y directo.",
  },
  {
    q: "¿Desde qué dispositivos puedo usarlo?",
    a: "Desde absolutamente cualquier dispositivo con conexión a internet. Funciona en celulares Android e iOS, computadoras con Windows o Mac, tablets y directamente desde el navegador web (Chrome, Safari, Firefox, etc.). No necesitas instalar nada — 100% en la nube, accede desde donde estés.",
  },
  {
    q: "¿Los programas tienen Inteligencia Artificial?",
    a: "¡Sí! Todos nuestros programas cuentan con Inteligencia Artificial integrada. Puedes consultarle a la IA que te genere un resumen de tus finanzas o tu inventario, detecte patrones, sugiera acciones y te dé insights en segundos. Es como tener un analista financiero disponible las 24 horas, listo para ayudarte a tomar mejores decisiones.",
  },
];

function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, inView };
}

export default function TestimoniosFaqSection() {
  const { ref: testRef, inView: testVisible } = useInView(0.1);
  const { ref: faqRef, inView: faqVisible } = useInView(0.1);
  const [openFaq, setOpenFaq] = useState<number | null>(null);

  return (
    <>
      {/* Testimonios */}
      <section
        id="testimonios"
        ref={testRef}
        className="bg-[#080808] py-20 md:py-28 px-6"
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        <div className="max-w-6xl mx-auto">
          <div
            className={`mb-14 transition-all duration-700 ${testVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <span className="text-[#00FF88] text-sm font-bold uppercase tracking-widest">Resultados Reales</span>
            <h2 className="text-3xl md:text-4xl font-black text-white mt-3">
              Lo que dice la comunidad:
            </h2>
            <div className="w-16 h-1 bg-[#00FF88] rounded-full mt-4" />
          </div>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            {/* Large testimonial */}
            <div
              className={`flex-1 transition-all duration-700 delay-200 ${
                testVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"
              }`}
            >
              <div
                className="relative bg-[#111] rounded-2xl p-8 md:p-10 h-full"
                style={{ borderLeft: "5px solid #00FF88" }}
              >
                <span
                  className="absolute top-6 right-8 text-8xl font-black leading-none opacity-10"
                  style={{ color: "#00FF88", fontFamily: "Georgia, serif" }}
                >
                  "
                </span>
                <p className="text-white text-xl leading-relaxed mb-8 relative z-10">
                  "{testimonios[0].quote}"
                </p>
                <div className="border-t border-white/10 pt-6 flex items-center gap-4">
                  <img
                    src={testimonios[0].avatar}
                    alt={testimonios[0].name}
                    className="w-14 h-14 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="text-white font-bold">{testimonios[0].name}</p>
                    <p className="text-gray-500 text-sm">{testimonios[0].role}</p>
                  </div>
                  <div className="ml-auto flex gap-1">
                    {[1,2,3,4,5].map((s) => (
                      <div key={s} className="w-4 h-4 flex items-center justify-center">
                        <i className="ri-star-fill text-[#00FF88] text-sm" />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Small testimonial - elevated */}
            <div
              className={`lg:w-80 lg:mt-12 transition-all duration-700 delay-400 ${
                testVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"
              }`}
            >
              <div
                className="relative bg-[#111] rounded-2xl p-8"
                style={{ borderLeft: "5px solid #FF6B35" }}
              >
                <span
                  className="absolute top-4 right-6 text-7xl font-black leading-none opacity-10"
                  style={{ color: "#FF6B35", fontFamily: "Georgia, serif" }}
                >
                  "
                </span>
                <p className="text-white text-base leading-relaxed mb-6 relative z-10">
                  "{testimonios[1].quote}"
                </p>
                <div className="border-t border-white/10 pt-5 flex items-center gap-3">
                  <img
                    src={testimonios[1].avatar}
                    alt={testimonios[1].name}
                    className="w-12 h-12 rounded-full object-cover flex-shrink-0"
                  />
                  <div>
                    <p className="text-white font-bold text-sm">{testimonios[1].name}</p>
                    <p className="text-gray-500 text-xs">{testimonios[1].role}</p>
                  </div>
                </div>
                <div className="flex gap-1 mt-4">
                  {[1,2,3,4,5].map((s) => (
                    <div key={s} className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-star-fill text-[#FF6B35] text-sm" />
                    </div>
                  ))}
                </div>
              </div>

              {/* Stats */}
              <div className="mt-6 bg-[#111] rounded-2xl p-6 border border-white/5">
                <div className="grid grid-cols-2 gap-4">
                  {[
                    { value: "+500", label: "Estrategas" },
                    { value: "98%", label: "Satisfacción" },
                    { value: "S/25", label: "Al año" },
                    { value: "24/7", label: "Acceso" },
                  ].map((stat) => (
                    <div key={stat.label} className="text-center">
                      <p className="text-[#00FF88] text-2xl font-black">{stat.value}</p>
                      <p className="text-gray-500 text-xs">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section
        id="faq"
        ref={faqRef}
        className="bg-[#0a0a0a] py-20 md:py-28 px-6"
        style={{ fontFamily: "'Montserrat', sans-serif" }}
      >
        <div className="max-w-3xl mx-auto">
          <div
            className={`text-center mb-14 transition-all duration-700 ${faqVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
          >
            <span className="text-[#FF6B35] text-sm font-bold uppercase tracking-widest">Resolvemos tus dudas</span>
            <h2 className="text-3xl md:text-4xl font-black text-white mt-3">¿Aún tienes dudas?</h2>
          </div>

          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <div
                key={faq.q}
                className={`bg-[#111] rounded-xl overflow-hidden border transition-all duration-300 ${
                  openFaq === i ? "border-[#00FF88]/40" : "border-white/5 hover:border-white/15"
                } ${faqVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                <button
                  className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
                  onClick={() => setOpenFaq(openFaq === i ? null : i)}
                >
                  <span className="text-white font-bold text-base md:text-lg pr-4">{faq.q}</span>
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i
                      className={`text-2xl transition-all duration-300 ${
                        openFaq === i ? "ri-subtract-line text-[#FF6B35]" : "ri-add-line text-[#00FF88]"
                      }`}
                    />
                  </div>
                </button>
                {openFaq === i && (
                  <div className="px-6 pb-6">
                    <div className="border-t border-white/10 pt-4">
                      <p className="text-gray-400 leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                        {faq.a}
                      </p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Footer CTA + Footer */}
      <section className="relative bg-[#080808] py-20 md:py-28 px-6 overflow-hidden" style={{ fontFamily: "'Montserrat', sans-serif" }}>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-96 h-96 bg-[#00FF88]/5 rounded-full blur-3xl" />
        </div>
        <div className="relative max-w-3xl mx-auto text-center">
          <p className="text-[#00FF88] text-sm font-bold uppercase tracking-widest mb-4">Último llamado</p>
          <h2 className="text-3xl md:text-5xl font-black text-white leading-tight mb-4">
            No dejes que otro mes se escape sin control
          </h2>
          <p className="text-gray-400 text-lg mb-10" style={{ fontFamily: "'Inter', sans-serif" }}>
            Únete a los estrategas que ya dominan sus números financieros y su inventario.
          </p>
          <a
            href="#"
            className="inline-flex items-center justify-center gap-3 bg-gradient-to-r from-[#00FF88] to-[#00cc6a] text-black font-black text-lg md:text-xl px-10 py-6 rounded-2xl hover:scale-105 transition-all duration-300 cursor-pointer text-center w-full sm:w-auto max-w-sm sm:max-w-none mx-auto"
            style={{ boxShadow: "0 0 50px rgba(0,255,136,0.35), 0 10px 40px rgba(0,0,0,0.5)" }}
          >
            <span className="leading-snug">
              ACCEDER AHORA<br className="block" />
              POR S/ 25/AÑO →
            </span>
          </a>
          <p className="text-gray-600 text-xs mt-5">
            Acceso inmediato · Respaldado en la nube · Sin contratos ni sorpresas
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer
        className="bg-[#050505] border-t border-white/5 py-12 px-6"
        style={{ fontFamily: "'Inter', sans-serif" }}
      >
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
            <div>
              <p className="text-white font-black text-2xl mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                SUPER<span className="text-[#00FF88]">PACK</span>
              </p>
              <p className="text-gray-500 text-sm leading-relaxed">
                El ecosistema definitivo para gestionar tu inventario y finanzas. Operar como un estratega real.
              </p>
            </div>
            <div>
              <p className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Navegación</p>
              <div className="flex flex-col gap-3">
                {["Sistemas", "Bonos", "Testimonios", "FAQ"].map((link) => (
                  <a
                    key={link}
                    href={`#${link.toLowerCase()}`}
                    className="text-gray-500 hover:text-white text-sm transition-colors cursor-pointer"
                  >
                    {link}
                  </a>
                ))}
              </div>
            </div>
            <div>
              <p className="text-white font-bold text-sm mb-4 uppercase tracking-wider">Soporte</p>
              <div className="flex flex-col gap-3">
                <p className="text-gray-500 text-sm">
                  <i className="ri-mail-line mr-2" />
                  soporte@superpack.pe
                </p>
                <p className="text-gray-500 text-sm">
                  <i className="ri-time-line mr-2" />
                  Lun–Vie 9am–6pm
                </p>
                <p className="text-gray-500 text-sm">
                  <i className="ri-shield-check-line mr-2 text-[#00FF88]" />
                  Acceso seguro y encriptado
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-gray-600 text-xs">
              © 2026 SuperPack · Todos los derechos reservados.
            </p>
            <div className="flex gap-6">
              <a href="#" className="text-gray-600 hover:text-white text-xs transition-colors cursor-pointer">Términos</a>
              <a href="#" className="text-gray-600 hover:text-white text-xs transition-colors cursor-pointer">Privacidad</a>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}
